import { sort } from '@/common/ts/share';
import { stat } from 'fs';

const im = {
    state: {
        //im实例
        IM: {},
        imstatus: '',
        account: 0, // 当前用户账户
        linemsgs: [],
        msgNum: 0 // 离线消息总条数
    },
    mutations: {
        setimstatus: (state, imstatus) => {
            console.log('setimstatus -- setimstatus');
            state.imstatus = imstatus;
        },
        setlinemsgs: (state, msg) => {
            if (Array.isArray(msg)) {
                state.linemsgs = state.linemsgs.concat(msg);
            } else if (msg instanceof Object) {
                state.linemsgs.push(msg);
            } else {
                console.error('setlinemsgs： 消息体必须是对象或者数组');
            }
        },
        updateLinemsgs: (state, list) => {
            state.linemsgs = [...list]
        },
        setaccount: (state, account) => {
            state.account = account;
        },
        setIM: (state, im) => {
            state.IM = im
            console.log('state.IM:::', state.IM);
        },
        setNum: (state, num) => {
            state.msgNum = num;
        }
    },
    actions: {
        setimstatus: ({ commit }, item) => {
            console.log('setimstatus -- actions');
            commit('setimstatus', item);
        },
        setlinemsgs: ({ commit }, item) => {
            commit('setlinemsgs', item);
        },
        updateLinemsgs: ({ commit }, item) => {
            commit('updateLinemsgs', item);
        },
        setaccount: ({ commit }, item) => {
            commit('setaccount', item);
        },
        setIM: ({ commit }, im) => {
            commit('setIM', im);
        },
        setNum: ({ commit }, num) => {
            commit('setNum', num);
        }
    },
    getters: {
        IM: function(state) {
            return state.IM;
        },
        // 对话消息列表[二维数组]
        msgList: function(state) {
            let list = new Map();
            //订单列表归类
            state.linemsgs.forEach(v => {
                let key = v.custom.orderNo ? v.custom.orderNo : JSON.parse(v.custom || '{}').orderNo;

                if (key) {
                    key *= 1;
                    let value = list.get(key);

                    if (value) {
                        value.push(v);
                    } else {
                        value = [v];
                    }
                    list.set(key, value);
                }
            });
            //订单子项消息排序
            list.forEach(v => {
                v.sort(function(a, b) {
                    return sort(b.time, a.time);
                });
            });
            return list;
        },
        msgNum: function(state) {
            return state.msgNum;
        },
        imstatus: function(state) {
            return state.imstatus;
        },
        account: function(state) {
            return state.account;
        }
    }
};

export default im;



// WEBPACK FOOTER //
// ./src/store/im/index.js